import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

interface IOneCardWrapper {
    backgroundImage?: string;
}
export const OneBenefitsCardWrapper = styled.div<IOneCardWrapper>(({ backgroundImage, theme }) => ({
    borderRadius: theme.spacing.medium,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing.medium,
    position: "relative",
    background: theme.colors[theme.colorMode].positive,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
    zIndex: 3,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    overflow: "hidden",
}));

export const CongratsAnimWrapper = styled.div`
    position: absolute;
    left: 25%;
`;

export const SmileyAnimWrapper = styled.div`
    width: 78px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const AmountWrapper = styled.div`
    width: 70%;
`;

interface IStyledTextProps {
    isMarginRight?: boolean;
}
export const OneBenefitsText = styled(Text)<IStyledTextProps>(({ isMarginRight, theme }) => ({
    display: "inline",
    marginRight: isMarginRight ? theme.spacing.xxSmall : theme.spacing.empty,
    verticalAlign: "middle",
}));

interface IStyledImageProps {
    isMarginRight?: boolean;
}

export const OneLogo = styled(Image)<IStyledImageProps>`
    margin-right: ${props => (props.isMarginRight ? props.theme.spacing.xxSmall : "0")};
    vertical-align: middle;
    z-index: 1000;
`;
